var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 69,
    viewBox: "0 0 60 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1896_3646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02403 61.5146L0 0.115234L60 0.238621L54.6876 61.5146L30.2264 68.5975L5.02403 61.5146Z",
    fill: "#1B73BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2266 62.6677V5.96283L54.9349 6.04509L50.5288 56.779L30.2266 62.6677Z",
    fill: "#1C88C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7986 13.2109H10.7891L11.8187 20.6229H29.8555L12.1071 28.2414L13.1363 35.4066H39.2862L38.3387 45.413L29.4849 47.1429L21.455 45.084L20.8371 39.4009H13.4658L14.4539 51.22L30.2673 55.6261L45.4221 50.8082L47.3576 27.7058H31.3376L48.7981 20.4584L48.7986 13.2109Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1896_3646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 68.7128,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode14);
export default __webpack_public_path__ + "static/media/code14.8a768365a96069accf2f303fb27346ed.svg";
export { ForwardRef as ReactComponent };